/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import type { Session } from "../ClientContext";

export const pendingGuestSessionKey = "matrix-pending-guest-session";
/** Keep the foreign credentials intact. Never send them to the current server. */
export function archiveForeignSession(storage: Storage): void {
  const raw =
    storage.getItem("matrix-auth-store") ??
    storage.getItem(pendingGuestSessionKey);
  if (!raw) return;
  const session = JSON.parse(raw) as Session;
  const key = `matrix-preserved-session:${encodeURIComponent(session.user_id)}:${encodeURIComponent(session.device_id)}`;
  storage.setItem(key, raw);
  if (storage.getItem(key) !== raw)
    throw new Error("Session archive unavailable");
  storage.removeItem("matrix-auth-store");
  storage.removeItem(pendingGuestSessionKey);
}
